import script from "./StringPropertiesPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./StringPropertiesPanel.vue?vue&type=script&lang=ts&setup=true"

import "./StringPropertiesPanel.vue?vue&type=style&index=0&id=48f023a6&scoped=true&lang=css"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48f023a6"]])

export default __exports__